const CHUNK_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading (?:CSS )?chunk [^ ]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
];

const recoveryKey = 'xcreate:recovered-chunk-errors';

function errorMessage(error) {
  return String(error?.message || error?.reason?.message || error || '');
}

export function isChunkLoadError(error) {
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(errorMessage(error)));
}

function chunkErrorSignature(error) {
  return errorMessage(error).replace(/\s+/g, ' ').slice(0, 500);
}

export function recoverFromChunkLoadError(error) {
  if (!isChunkLoadError(error)) return false;

  const signature = chunkErrorSignature(error);
  let recovered = [];
  try {
    recovered = JSON.parse(window.sessionStorage.getItem(recoveryKey) || '[]');
  } catch (_) {
    recovered = [];
  }
  if (recovered.includes(signature)) return false;

  window.sessionStorage.setItem(recoveryKey, JSON.stringify([...recovered.slice(-4), signature]));
  window.location.reload();
  return true;
}

export function installChunkLoadRecovery(router) {
  router.onError((error) => recoverFromChunkLoadError(error));
  window.addEventListener('error', (event) => recoverFromChunkLoadError(event.error || event.message));
  window.addEventListener('unhandledrejection', (event) => {
    if (recoverFromChunkLoadError(event.reason)) event.preventDefault();
  });
}
